import { render, staticRenderFns } from "./tyokertymalaskuri.vue?vue&type=template&id=677c3e02&scoped=true&"
import script from "./tyokertymalaskuri.vue?vue&type=script&lang=ts&"
export * from "./tyokertymalaskuri.vue?vue&type=script&lang=ts&"
import style0 from "./tyokertymalaskuri.vue?vue&type=style&index=0&id=677c3e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677c3e02",
  null
  
)

export default component.exports